const GET = 'GET';
const POST = 'POST';
const PUT = 'PUT';
const DELETE = 'DELETE';
const PATCH = 'PATCH';
const HEAD = 'HEAD';
const TRACE = 'TRACE';
const OPTIONS = 'OPTIONS';
const CONNECT = 'CONNECT';

const HttpMethods = {
  GET,
  POST,
  PUT,
  DELETE,
  PATCH,
  HEAD,
  TRACE,
  OPTIONS,
  CONNECT,
};

export default HttpMethods;